<template lang="html">
<div class="pgInner matchEdit">

    <div class="headBar">申报匹配结果</div>

    <div class="pgbody" :style="'height:' + pageH + 'px;'">

        <div class="rowsLine clearfix">

             <div class="iTerm">
                  <div class="iName">发布者</div>
                  <div class="iContent">{{itemDat.userName}}</div>
             </div>

             <div class="iTerm">
                  <div class="iName">所属企业</div>
                  <div class="iContent">{{itemDat.enterpriseName}}</div>
             </div>

             <div class="iTerm">
                  <div class="iName">发布时间</div>
                  <div class="iContent">{{itemDat.updatedAt}}</div>
             </div>

        </div>

        <div class="rowsLine clearfix">

              <div class="iTerm">
                   <div class="iName">产业方向</div>
                   <div class="iContent">{{itemDat.policyTypeIdName}}</div>
              </div>

              <div class="iTerm">
                   <div class="iName">企业类型</div>
                   <div class="iContent">{{itemDat.subjectTypeName}}</div>
              </div>

        </div>

        <div class="rowsLine clearfix">

              <div class="iTerm">
                   <div class="iName">近一年营业收入</div>
                   <div class="iContent">
                      {{itemDat.operatingIncome}}
                   </div>
              </div>

              <div class="iTerm">
                   <div class="iName">近一年企业利润</div>
                   <div class="iContent">
                      {{itemDat.corporateProfits}}
                   </div>
              </div>

              <div class="iTerm">
                   <div class="iName">近一年研发经费</div>
                   <div class="iContent">
                      {{itemDat.technologyFunding}}
                   </div>
              </div>

        </div>

        <div class="rowsLine clearfix">

              <div class="iTerm">
                   <div class="iName">人员规模</div>
                   <div class="iContent">
                      {{itemDat.numberOfParticipantsName}}
                   </div>
              </div>

              <div class="iTerm">
                   <div class="iName">知识产权</div>
                   <div class="iContent">
                      {{itemDat.intellectualPropertyName}}
                   </div>
              </div>

              <div class="iTerm">
                   <div class="iName">发明专利</div>
                   <div class="iContent">
                      {{itemDat.patentName}}
                   </div>
              </div>

        </div>

        <el-table
           :data="pocList"
           header-row-class-name="tableHead"
           @selection-change="tabSelect"
           v-loading="loading"
           style="width: 100%;margin-top:60px;">

           <el-table-column
             prop="policyTypeIdName"
             label="申报标题">
           </el-table-column>

           <el-table-column
             prop="policyTypeIdName"
             width="180"
             align="center"
             label="政策分类">
           </el-table-column>

        </el-table>

        <div class="table-footer">

            <el-pagination
              class="paging"
              v-if="allPages>1"
              @current-change="handleCurrentChange"
              :current-page="listParams.no"
              :page-count="allPages"
              layout="total, prev, pager, next, jumper">
            </el-pagination>

        </div>

        <div class="footBlock">
          <el-button @click="goBack" size="medium">返回</el-button>
        </div>


    </div>

</div>
</template>

<script>

import { getMatchs,matchPocs } from "@/api/enterprise/index";
import { getEnterpriseList } from "@/api/attes/attestation";

export default {
    data(){
        return{
            id:'',
            radio:1,
            itemDat:{},

            pocList:[],
            params:{
                userId:'',
                no:1,
                size:12
            }
        }
    },

    methods:{
        goReturn:function(){
            this.$router.go(-1);
        },

        pageFix:function(){
            this.pageH = document.documentElement.clientHeight - 205;
        },

        prevSet:function(){

            var vues = this;
            var querys = this.$route.query;

            if(querys.id){
                getMatchs({userId:querys.id}).then(res => {
                    vues.itemDat = res.declareMyMatchConditionsList[0];
                });
                matchPocs(this.params).then(res => {
                    vues.pocList = res.declarationPolicyList;
                });
            }

            // 底部定位
            this.pageFix();
        },

        goBack(){
           this.$router.go(-1);
        }

    },
    created:function(){
        var vues = this;
        var querys = this.$route.query;

        this.prevSet();
        $(window).resize(function(){
    		     vues.pageFix();
             vues.$refs.scroller.$data.sizeHeight = this.pageH;
    	  })

    }


}
</script>

<style lang="scss" scoped>

.pgInner{
  background: #f5f5f5;
}

.headBar{
  height: 55px;
  line-height: 55px;
  font-size: 16px;
  padding-left: 20px;
  background: white;
}

.matchEdit .pgbody{
  margin: 20px;
  padding: 20px;
  font-size: 15px;
  background: white;
}

.textLine{
   margin-bottom: 20px;
   font-size: 15px;
}

.textLine .itemGp{
  width: 36%;
  height: 45px;
  float: left;
  position: relative;
}

.textLine .itemGp .iName{
  width: 80px;
  padding-top: 9px;
  float: left;
}

.textLine .itemGp .iContent{
  margin-left: 80px;
  .iInp{
      width: 270px;
  }
}

.radioContent{
    padding-top: 12px;
}

.rowsLine{
    margin-bottom: 30px;
    .iTerm{
        width: 32%;
        float: left;
        position: relative;
        .iName{
            width: 120px;
            float: left;
        }
        .iContent{
            margin-left: 120px;
            color:#999999;
        }
    }
}

.pagefoot{
  height: 60px;
  line-height: 60px;
  background: white;
  padding-left: 20px;
  position: relative;
  z-index: 2;
  .btn{
    height: 32px;
    padding: 0 12px;
    margin-right: 12px;
    display: inline-block;
    font-size: 14px;
    cursor: pointer;
  }
  .type1{
    line-height: 32px;
    background: rgb(86, 119, 252);
    color: white;
  }
  .type2{
    box-sizing: border-box;
    border: 1px solid #aeaeae;
    line-height: 30px;
  }

  .loading{
     font-size: 14px;
     padding-left: 24px;
     color: #AEAEAE;
     i{
         font-size: 18px;
         vertical-align: middle;
     }
  }

  .table-footer{
    height: 50px;
    background: white;
    padding: 0 30px;
    text-align: right;

    .btns{
      float: left;
      line-height: 50px;
    }

    .paging{
      display: inline-block;
      margin-top: 9px;
    }
  }

}

.footBlock{
    text-align: center;
    margin-top: 90px;
    .el-button{
        width: 120px;
    }
}

</style>

<style lang="css">

.matchEdit .tableHead th{
   background: #efefef;
   font-weight: normal;
   color: #666666;
}

</style>



// WEBPACK FOOTER //
// matchView.vue?304865a7